import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import { paths } from '@/app/paths';
import { AdminConfirmProvider } from '../shared/AdminConfirmProvider';
import { useAdminListParams } from '../shared/useAdminListParams';
import { AdminListToolbar } from '../shared/AdminListToolbar';
import { getUserFilters } from './UsersTable/UserFilters';
import { UsersTable } from './UsersTable';
import { UserDrawer } from './UserDrawer';

/**
 * Admin users list: the toolbar (search, filters, Import and New user), the users grid
 * (UsersTable) and the user drawer. Clicking a row opens its edit drawer (the :userId
 * route), and New user opens the drawer to create one (the new route); UserDrawer is always
 * rendered so it can animate.
 */
export const UsersListPage = () => {
	const navigate = useNavigate();
	const { search: locationSearch } = useLocation();
	const { gridProps, search, setSearch, filters, setFilter, clearFilters } =
		useAdminListParams('users');

	return (
		<AdminConfirmProvider>
			<AdminListToolbar
				search={search}
				onSearchChange={setSearch}
				filters={getUserFilters({ filters, setFilter })}
				onClearFilters={clearFilters}
				primaryActions={
					<>
						<Button
							variant='contained'
							startIcon={<UploadFileIcon />}
							onClick={() => navigate(`${paths.admin}/import/users`)}
						>
							Import
						</Button>
						<Button
							variant='contained'
							startIcon={<AddIcon />}
							onClick={() => navigate({ pathname: 'new', search: locationSearch })}
						>
							New user
						</Button>
					</>
				}
			/>
			<UsersTable search={search} filters={filters} gridProps={gridProps} />
			<UserDrawer />
		</AdminConfirmProvider>
	);
};
